import cn from 'classnames'
import React from 'react'

//
import Statistic from '../Statistic'
import { THEME } from '@/src/utils/common'

const Statistics = ({
  statistics = [],
  classes = '',
  vertical = false,
  theme,
  containerDefaultSpacing = true,
  statisticsClasses = ''
}) => {
  return (
    <section
      className={cn('l-section', classes, {
        'l-section--dark': theme === THEME.dark
      })}
    >
      <div
        className={cn(
          'l-container:12/12',
          containerDefaultSpacing && 'l-container--default-spacing'
        )}
      >
        <div
          className={cn(
            `${
              !vertical ? 'l-grid' : 'c-statistics--vertical'
            } l-grid--default-spacing l-grid--align:center`,
            statisticsClasses
          )}
        >
          {statistics?.map(({ number, unit, title, description, ...rest }, i) => (
            <Statistic
              key={`${title}-${i}`}
              number={number || ''}
              unit={unit || ''}
              title={title || ''}
              text={description || ''}
              {...rest}
              classes={`${
                vertical
                  ? 'c-statistic--vertical'
                  : 'l-grid__col:4/12 l-grid__col:6/12@to:viewport-7 l-grid__col:12/12@to:viewport-4'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Statistics
